/**
 * @description
 * Objeto parameters
 */

export class Parameters {
    public id:number = null;
    public code:string = "";
    public desc:string;
    public value:string;
    public typevalue:number = null;

    constructor() {}
  
}